var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "op-input" },
    [
      !_vm.isReadonly
        ? _c(
            "el-input",
            _vm._g(
              _vm._b(
                { attrs: { size: "mini" } },
                "el-input",
                _vm.$attrs,
                false
              ),
              _vm.$listeners
            ),
            [
              _vm._t("prepend", null, { slot: "prepend" }),
              _vm._v(" "),
              _vm._t("append", null, { slot: "append" }),
            ],
            2
          )
        : _c("span", { staticClass: "op-input-txt" }, [
            _vm._v(_vm._s(_vm.inputValue || "-")),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }